import React from "react";
import { House, Buildings, Sparkle } from "@phosphor-icons/react";

export default function StepResidency({ value, onSelect }) {
  return (
    <div data-testid="step-residency" className="max-w-3xl mx-auto">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 bg-sky-50 border border-sky-200 rounded-full px-4 py-1.5 mb-5">
          <Sparkle size={14} weight="fill" className="text-sky-600" />
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-sky-700">
            One quick question
          </span>
        </div>
        <h2 className="font-display text-4xl sm:text-5xl font-bold text-slate-950 tracking-tight">
          Do you own or rent?
        </h2>
        <p className="mt-3 text-slate-600 text-lg">
          We tailor your savings plan accordingly. Renters get TOU coaching + efficiency
          tips. Owners get the full path: tips, financing, and solar if it fits.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => onSelect("owner")}
          data-testid="residency-owner"
          className={`text-left p-8 rounded-3xl border-2 transition-all bg-white hover:border-sky-400 hover:shadow-lg ${
            value === "owner" ? "border-sky-500 ring-4 ring-sky-500/15 shadow-lg" : "border-slate-200"
          }`}
        >
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-sky-500 to-sky-600 flex items-center justify-center mb-5">
            <House size={28} weight="duotone" className="text-white" />
          </div>
          <h3 className="font-display text-2xl font-semibold text-slate-900">I'm a homeowner</h3>
          <p className="text-slate-600 mt-2 leading-relaxed">
            Get the full plan — TOU shifts, solar+battery sizing, financing options
            (Unlock equity, conventional loans), HVAC partners, and 35% tax-equity offset
            (waitlist).
          </p>
          <div className="mt-4 text-xs uppercase tracking-wider text-emerald-700 font-bold">
            Full analysis &middot; ~6 quick questions
          </div>
        </button>

        <button
          type="button"
          onClick={() => onSelect("renter")}
          data-testid="residency-renter"
          className={`text-left p-8 rounded-3xl border-2 transition-all bg-white hover:border-amber-400 hover:shadow-lg ${
            value === "renter" ? "border-amber-500 ring-4 ring-amber-500/15 shadow-lg" : "border-slate-200"
          }`}
        >
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center mb-5">
            <Buildings size={28} weight="duotone" className="text-white" />
          </div>
          <h3 className="font-display text-2xl font-semibold text-slate-900">I rent</h3>
          <p className="text-slate-600 mt-2 leading-relaxed">
            Skip the solar steps. We'll show you exact TOU shift savings (often $20-60/mo),
            efficiency tips, and connect you with HVAC partners and rebate programs you
            can use today.
          </p>
          <div className="mt-4 text-xs uppercase tracking-wider text-amber-700 font-bold">
            Quick analysis &middot; 2 more questions
          </div>
        </button>
      </div>
    </div>
  );
}
